import type { AlertColor } from "@mui/material";

/**
 * Get icon color based on severity while maintaining dark background.
 * Used for consistent notification styling across the application.
 *
 * @param severity - The severity level of the notification
 * @returns The hex color code for the icon
 */
export const getNotificationIconColor = (severity: AlertColor): string => {
  switch (severity) {
    case "success":
      return "#4caf50"; // Green
    case "error":
      return "#f44336"; // Red
    case "warning":
      return "#ff9800"; // Orange
    case "info":
      return "#2196f3"; // Blue
    default:
      return "inherit";
  }
};
